'use client';

import {useI18n} from '@udemy-v2/i18n';
import {useClpPurchaseContext} from '@/features/course-landing-page/context/clp-purchase-context.react-component';
import {useClpCourse} from '@/features/course-landing-page/context/clp-course-provider.react-component';
import {
    PlanPeriodStyle,
    SubscriptionCTA,
    SubscribeFromPageCookie,
} from '@udemy-v2/react-subscription-browse';
import styles from '../subscription-sticky-footer-content/subscription-sticky-footer-cta.module.scss';

const UI_REGION = 'non_catalog_pp_sticky_footer';

export const NonCatalogPPStickyFooterCta = () => {
    const {gettext} = useI18n();
    const {nonCatalogPersonalPlan, nonCatalogSubscriptionCTAConfiguration} =
        useClpPurchaseContext();
    const course = useClpCourse();

    const handleCtaClick = () => {
        SubscribeFromPageCookie.set('course_landing_page', parseInt(course.id, 10));
    };

    if (!nonCatalogPersonalPlan) {
        return null;
    }

    const ctaUrl = `/subscription-checkout/express/?non-catalog-course=${encodeURIComponent(course.id)}`;

    return (
        <div data-testid="non-catalog-pp-sticky-footer" data-purpose="non-catalog-pp-sticky-footer">
            <SubscriptionCTA
                className={styles['subscription-cta']}
                uiRegion={UI_REGION}
                subtitleClassName={styles['cta-subtitle']}
                data-purpose="non-catalog-pp-sticky-footer-button"
                offerCtaStyle="primary"
                onCTAClick={handleCtaClick}
                courseId={parseInt(course.id, 10)}
                courseTrackingId={course.frontendTrackingId}
                includeTrialDaysOnCta={false}
                plan={nonCatalogPersonalPlan}
                directCheckout={nonCatalogSubscriptionCTAConfiguration?.directCheckout ?? true}
                purchaseCtaText={
                    nonCatalogSubscriptionCTAConfiguration?.purchaseCtaText ??
                    gettext('Start subscription')
                }
                noticeData={{cta_1_url: ctaUrl}}
                planPeriodStyle={PlanPeriodStyle.SINGLE}
            />
        </div>
    );
};
